module.exports = __webpack_public_path__ + "static/akmap-be876fd1ebedd6034e5c08e1612ffdd5.svg";